import { render } from "./ReverseLifecycleTAT.vue?vue&type=template&id=74c2d5d4"
import script from "./ReverseLifecycleTAT.vue?vue&type=script&lang=js"
export * from "./ReverseLifecycleTAT.vue?vue&type=script&lang=js"

import "./ReverseLifecycleTAT.vue?vue&type=style&index=0&id=74c2d5d4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__